function OnsiteViewButtons($rootScope, $timeout, filterService) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            hideActiveOnly: '=?',
            reports: '=',
            filterReport: '='
        },
		template: require('./view-buttons.html'),

        link: function (scope) {
            scope.hideActiveOnly = scope.hideActiveOnly || false;
            scope.canWrite = $rootScope.selectedLog.role === 'WRITE' || $rootScope.selectedLog.role === "ADMIN";
            scope.displayOptions = filterService.getMasterDisplayOptions();

            scope.showCreateVisitModal = function () {
                $('#create-visit-modal').modal('show');
            };

            scope.toggleActiveOnly = function () {
                scope.displayOptions.showActiveOnly = !scope.displayOptions.showActiveOnly;
                filterService.setMasterDisplayOptions(scope.displayOptions);
            };

            scope.toggleComments = function () {
                scope.displayOptions.showComments = !scope.displayOptions.showComments;
                filterService.setMasterDisplayOptions(scope.displayOptions);
            };

            scope.filterChanged = function () {
                $timeout(function () {
                    $rootScope.$broadcast('onsite-filter-changed');
                });
            }; 
        }
    }
}

angular.module('onsite').directive('onsiteViewButtons', ['$rootScope', '$timeout', 'onsiteUiFilterService', OnsiteViewButtons]);
